import { IEntity } from '@infodata-group/inf-commons';
import { ReportDetailExportInterface } from '../../interface/report/report-detail-export.interface';
import * as uuid from 'uuid';

export class AoReportDetail implements IEntity {
  public id = uuid.v4();
  lock: boolean;
  heureDebut: string;
  heureFin: string;
  duree: string;
  km = 0;
  position: string;
  latitude: number;
  longitude: number;
  adresse: string;
  private _chantier: any;

  public get chantier(): any {
    return this._chantier;
  }

  public set chantier(site: any) {
    this._chantier = site;
    if (site.color) {
      this.dataTableColor = `${site.color}99`;
    }
  }

  chauf: string;
  com: string;
  grpChantier: {
    id: string;
    lib: string;
  };
  vehicule: {
    bbx: string;
    lib: string;
    imm: string;
  };

  public dataTableColor = '#ffffff';

  getId(): string {
    return this.id;
  }

  getLabel(): string {
    return '';
  }

  toExport(): ReportDetailExportInterface {
    return {
      time: this.heureDebut,
      duration: this.duree,
      km: this.km,
      position: this.position,
      com: this.com,
      address: this.adresse,
      site: this.chantier as string,
    };
  }

  serialize(): any {
    return {};
  }
}
